import { render, staticRenderFns } from "./CustomChip.vue?vue&type=template&id=6543c739&scoped=true"
import script from "./CustomChip.vue?vue&type=script&lang=js"
export * from "./CustomChip.vue?vue&type=script&lang=js"
import style0 from "./CustomChip.vue?vue&type=style&index=0&id=6543c739&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6543c739",
  null
  
)

export default component.exports